import {
  List,
  Datagrid,
  ChipField,
  ReferenceField,
  BooleanInput,
  BooleanField,
  TextField,
  ImageField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  Create,
  SelectInput,
  Show,
  SimpleShowLayout,
  RichTextField,
  DateField,
  required,
} from 'react-admin'
import { CustomRichTextInput } from '../components/CustomRichTextInput'

import { USER_TYPE_OPTIONS, PHASE_TYPE_OPTIONS, ARTICLE_TYPE_OPTIONS } from '../config/constants'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ArticleList = ({ isEdit, isDelete }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="phaseType" />
      <ChipField source="type" />
      <TextField source="title" />
      <DateField source="updatedAt" label="Updated At" showTime />
      {/*<ImageField source="imageUrl" title="imageUrl" />*/}
      <ReferenceField source="updatedBy" reference="users" />
      {isDelete && <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />}
    </Datagrid>
  </List>
)

export const ArticleEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" fullWidth multiline />
      <TextInput source="description" fullWidth multiline />
      <CustomRichTextInput size="medium" source="text" fullWidth />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
      <ImageField source="previewImageUrl" title="previewImageUrl" />
      <ImageInput source="previewImage">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
)

export const ArticleCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput source="userType" choices={USER_TYPE_OPTIONS} validate={required()} />
      <BooleanInput source="isOverweight" label="Is Overweight" validate={required()} />
      <SelectInput source="phaseType" choices={PHASE_TYPE_OPTIONS} validate={required()} />
      <SelectInput source="type" choices={ARTICLE_TYPE_OPTIONS} validate={required()} />
      <TextInput source="title" fullWidth multiline validate={required()} />
      <TextInput source="description" fullWidth multiline validate={required()} />
      <CustomRichTextInput size="medium" source="text" fullWidth validate={required()} />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
      <ImageField source="previewImageUrl" title="previewImageUrl" />
      <ImageInput source="previewImage">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
)

export const ArticleShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="phaseType" />
      <ChipField source="type" />
      <TextField source="title" />
      <TextField source="description" />
      <RichTextField source="text" />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageField source="previewImageUrl" title="previewImageUrl" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
